import { createContext, useContext, PropsWithChildren } from 'react'

export interface WellState {
  isDraft?: boolean
  isPublished?: boolean
  isUnderReview?: boolean
  isDecommissionedWell?: boolean
  isExistingWell?: boolean
  isGeothermalWell?: boolean
  isLegacyWell?: boolean
  isNotDrilledWell?: boolean
  hasNoYieldRecords?: boolean
  hasNoAquiferTestRecords?: boolean
  councilId?: number
}

const WellContext = createContext<{ wellState: WellState } | undefined>(undefined)

export default function WellStateProvider({ children, wellState }: PropsWithChildren<{ wellState: WellState }>) {
  return <WellContext.Provider value={{ wellState }}>{children}</WellContext.Provider>
}

function useWellState() {
  const context = useContext(WellContext)
  if (context === undefined) {
    throw new Error('useWellState must be used within a WellProvider')
  }
  return context
}

export { useWellState }
